import {applyMiddleware, compose, combineReducers} from 'redux';
// import alertsReducer, {alertsInitialState} from './alerts';
// import colorPickerReducer, {colorPickerInitialState} from './color-picker';
// import editorTabReducer, {editorTabInitialState} from './editor-tab';
import fontsLoadedReducer, {fontsLoadedInitialState} from './fonts-loaded';
import localesReducer, {localesInitialState} from './locales';
import modalsReducer, {modalsInitialState} from './modals';
import modeReducer, {modeInitialState} from './mode';
import monitorLayoutReducer, {monitorLayoutInitialState} from './monitor-layout';
import monitorReducer, {monitorsInitialState} from './monitors';
import projectTitleReducer, {projectTitleInitialState} from './project-title';
import projectStateReducer, {projectStateInitialState} from './project-state';
import stageSizeReducer, {stageSizeInitialState} from './stage-size';
import targetReducer, {targetsInitialState} from './targets';
import vmReducer, {vmInitialState} from './vm';
import vmStatusReducer, {vmStatusInitialState} from './vm-status';
import throttle from 'redux-throttle';

const guiMiddleware = compose(applyMiddleware(throttle(300, {leading: true, trailing: true})));

const guiInitialState = {
    // alerts: alertsInitialState,
    // colorPicker: colorPickerInitialState,
    // editorTab: editorTabInitialState,
    fontsLoaded: fontsLoadedInitialState,
    locales: localesInitialState,
    modals: modalsInitialState,
    mode: modeInitialState,
    monitorLayout: monitorLayoutInitialState,
    monitors: monitorsInitialState,
    projectTitle: projectTitleInitialState,
    projectState: projectStateInitialState,
    stageSize: stageSizeInitialState,
    targets: targetsInitialState,
    vm: vmInitialState,
    vmStatus: vmStatusInitialState
};

const initPlayer = function (currentState) {
    return Object.assign(
        {},
        currentState,
        {mode: {
                isFullScreen: currentState.mode.isFullScreen,
                isPlayerOnly: true,
                // When initializing in player mode, make sure to reset
                // hasEverEnteredEditorMode
                hasEverEnteredEditor: false
            }}
    );
};

const initFullScreen = function (currentState) {
    return Object.assign(
        {},
        currentState,
        {mode: {
                isFullScreen: true,
                isPlayerOnly: currentState.mode.isPlayerOnly,
                hasEverEnteredEditor: currentState.mode.hasEverEnteredEditor
            }}
    );
};

const initEmbedded = function (currentState) {
    return Object.assign(
        {},
        currentState,
        {mode: {
                showBranding: true,
                isFullScreen: true,
                isPlayerOnly: true,
                hasEverEnteredEditor: false
            }}
    );
};

// const initTelemetryModal = function (currentState) {
//     return Object.assign(
//         {},
//         currentState,
//         {
//             modals: {
//                 telemetryModal: true // this key must match `MODAL_TELEMETRY` in modals.js
//             }
//         }
//     );
// };

const guiReducer = combineReducers({
    // alerts: alertsReducer,
    // colorPicker: colorPickerReducer,
    // editorTab: editorTabReducer,
    fontsLoaded: fontsLoadedReducer,
    locales: localesReducer,
    modals: modalsReducer,
    mode: modeReducer,
    monitorLayout: monitorLayoutReducer,
    monitors: monitorReducer,
    projectTitle: projectTitleReducer,
    projectState: projectStateReducer,
    stageSize: stageSizeReducer,
    targets: targetReducer,
    vm: vmReducer,
    vmStatus: vmStatusReducer
});

export {
    guiReducer as default,
    guiInitialState,
    guiMiddleware,
    initEmbedded,
    initFullScreen,
    initPlayer,
    // initTelemetryModal
    /* 去掉教程@米德 */
    // initTutorialCard
};
